function noop() {}
noop._name = 'react_rating_noop';

export default noop;
